import {ErrorHandler, Inject, Injectable, Injector} from '@angular/core';
import Rollbar from 'rollbar';
import {Payload} from 'rollbar';
import {NavService} from './_nav.service';
import {AutenticacionService} from './autenticacion.service';
import {AppSettings} from '../../proyect.conf';
import {rollbarConfig, RollbarService} from './rollbar.service';

@Injectable({
    providedIn: 'root',
})
export class RollbarErrorHandler implements ErrorHandler {

    version: string;

    idUsuario: string;

    authService: any;

    navService: any;

    constructor(@Inject(RollbarService) private rollbar: Rollbar,
                private injector: Injector) {
    }


    async handleError(err: any) {
 /*     //se agrega esta línea con el fin de capturar el error item que arroja el splitbutton en unidad de credito
        seto se da por incompatibilad de la version de angular y primeng*/
        if (err?.message?.includes('focusedItemInfo.mutate')) {
          console.warn('alerta de SplitButton/TieredMenu');
          return;
        }
      if (!this.navService) {
          this.navService = this.injector.get(NavService);
        }

        if (!this.authService) {
          this.authService = this.injector.get(AutenticacionService);
        }

        if ( !this.version && this.navService ) {
            this.version = this.navService.buscarMensaje('LBL_VERSIONSISTEMA');
            this.rollbar.options.version = this.version;
            this.rollbar.configure(this.rollbar.options);
        }

        if ( this.authService && (!this.idUsuario || this.idUsuario !== this.authService.obtenerIdUsuarioLogueado())){
            this.rollbar.options.payload = {
                person: {
                    id: this.authService.obtenerIdUsuarioLogueado(),
                    username: this.authService.obtenerUsuario().usuarioSistema
                }
            } as Payload;
            this.rollbar.configure(this.rollbar.options);
        }

        if ( AppSettings.produccion ) {
            this.rollbar.error(err);
        } else {
            console.log(err);
        }
    }
}

export function rollbarFactory() {
    return new Rollbar( rollbarConfig );
}
